import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIdCopy } from "@hooks/useIdCopy";

export const InvoiceNumberCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, InvoiceLineItem, string | null>) => {
        const { getCopyProps } = useIdCopy({ label: "Invoice" });
        const invoice = row.original.invoice;

        return (
            <ViewTableCell>
                <span {...getCopyProps(invoice?.id)}>
                    {invoice?.invoiceNumber}
                </span>
            </ViewTableCell>
        );
    },
);
